export default __webpack_public_path__ + "static/media/Trafficinfo1.3c8b80c9.png";